<template>
  <div>
    <SearchMinInput
      class="search-form__lower-budget"
      placeholder="下限なし"
      :default-value="lowerBudget"
      @inputted="onInputLowerBudget"
    />
    <div class="search-form__range-mark">
      〜
    </div>
    <SearchMinInput
      class="search-form__upper-budget"
      placeholder="上限なし"
      :default-value="higherBudget"
      @inputted="onInputHigherBudget"
    />
  </div>
</template>

<script>
import SearchMinInput from './SearchMinInput'

export default {
  components: {
    SearchMinInput
  },
  props: {
    lowerBudget: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    higherBudget: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    }
  },
  methods: {
    onInputLowerBudget(value) {
      this.$emit('inputted-lower-budget', value)
    },
    onInputHigherBudget(value) {
      this.$emit('inputted-higher-budget', value)
    }
  }
}
</script>
